import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import ViewUI from 'view-design'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import 'view-design/dist/styles/iview.css'
import './permission'
import 'echarts/theme/essos.js'
import echarts from "echarts"
import JSEncrypt from 'jsencrypt';

Vue.config.productionTip = false
Vue.use(ViewUI)

// 设置基础URL
axios.defaults.baseURL = ''
// 设置请求超时时间
axios.defaults.timeout = 20000
Vue.prototype.$echarts = echarts
Vue.prototype.$axios = axios

Vue.prototype.$getRsaCode = function(str) { // 注册方法
    var PUBLIC_KEY = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC8HMr2CBpoZPm3t9tCVlrKtTmI4jNJc7/HhxjIEiDjC8czP4PV+44LjXvLYcSV0fwi6nE4LH2c5PBPEnPfqp0g8TZeX+bYGvd70cXee9d8wHgBqi4k0J0X33c0ZnW7JruftPyvJo9OelYSofBXQTcwI+3uIl/YvrgQRv6A5mW01QIDAQAB';
    let encryptStr = new JSEncrypt();
    encryptStr.setPublicKey('-----BEGIN PUBLIC KEY-----' + PUBLIC_KEY + '-----END PUBLIC KEY-----');
    let data = encryptStr.encrypt(str.toString());  // 进行加密
    return data;
}

//已经为ajax请求设置了loading 请求前自动调用 请求完成自动结束
axios.interceptors.request.use(config => {
    //this.showLoading = true
    if (localStorage.token) { //判断token是否存在
        config.headers.Authorization = localStorage.token;  //将token设置成请求头
    }
    else{
        config.headers.Authorization = ""
    }
    // 在发送请求之前做些什么
    return config
}, error => {
    //this.showLoading = false
    console.log(error)
    // 对请求错误做些什么
    return Promise.reject(error)
})
// 添加响应拦截器
axios.interceptors.response.use(response => {
    // 可以在这里对返回的数据进行错误处理 如果返回的 code 不对 直接报错或退出登陆
    // 就可以省去在业务代码里重复判断
    // 例子
    // if (res.code != 0) {
    //     this.$Message.error(res.msg)
    //     return Promise.reject()
    // }
    //this.showLoading = false
    //console.log("返回data:", response["data"])
    if ("data" in response) {
        return response["data"]
    } 
    else {
        return response
    }
}, error => {
    console.log(error)
    // //this.showLoading = false
    // switch (error.response.status) {
    //     case 401:
    //         resetTokenAndClearUser();
    //         router.replace({ name: "login" });
    // }
    // 对响应错误做点什么
    return Promise.reject(error)
})

new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
})